import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable()
export class OktaState {
    public isLoggedIn$: BehaviorSubject<string> = new BehaviorSubject<string>(null)
    public isLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)

    setIsLoggedIn(value: string) {
        this.isLoggedIn$.next(value)
    }

    setIsLoaded(value: boolean) {
        this.isLoaded$.next(value)
    }
}
